export default "__VITE_ASSET__855c5f75__"